import ApolloClient from 'apollo-boost';
import config from '../../config';

function createApolloClient({ initialState = {} }) {
  return new ApolloClient({ uri: config.REACT_APP_GRAPHQL_URI, credentials: 'include' });
}

const apolloClient = createApolloClient({});

export default apolloClient;



// WEBPACK FOOTER //
// ./src/_app/middleware/apolloClient.js